import { useState } from "react";
import { IoClose } from "react-icons/io5";

import Modal from "../../../components/common/Modal";
import TableControls from "../../../components/common/TableControls";
import TableSize from "../../../components/common/TableSize";
import TextboxSearch from "../../../components/common/TextboxSearch";

import taxService from "../../../services/taxService";
import ReceiptFilter from "./ReceiptFilter";

const ReceiptHeader = ({ options, onChange }) => {
  const [showFilter, setShowFilter] = useState(false);

  const settings = [
    {
      id: 1,
      content: (
        <TableSize size={options.size} onChange={(e) => handleSizeChange(e)} />
      ),
    },
  ];

  const quarters = taxService.getAltTaxQuarters();

  const handleSizeChange = (event) => {
    const size = event.target.value;

    if (size !== options.size) {
      const new_options = { ...options };
      new_options.size = size;
      new_options.current_page = 1;
      onChange(new_options);
    }
  };

  const handleSearch = (query) => {
    const new_options = { ...options };

    if (new_options.search_query !== query) {
      new_options.year = "";
      new_options.quarter = "";
      new_options.verified = "";
      new_options.search_query = query;
      new_options.current_page = 1;
      onChange(new_options);
    }
  };

  const handleFilter = (year, quarter, verified) => {
    const new_options = { ...options };
    new_options.year = year;
    new_options.quarter = quarter;
    new_options.is_verified = verified;

    onChange(new_options);
    setShowFilter(false);
  };

  const handleRemoveFilter = (item) => {
    const new_options = { ...options };
    if (item === 1) new_options["year"] = "";
    if (item === 2) new_options["quarter"] = "";
    if (item === 3) new_options["is_verified"] = "";
    onChange(new_options);
  };

  const renderQuarter = (quarter) => {
    const selected = quarters.filter((i) => i.value === quarter);
    return selected[0].label;
  };

  return (
    <>
      <div className="block lg:flex justify-between items-center">
        <div>
          <p className="text-gray-500 text-sm">Official Receipts</p>
          <span className="text-gray-400 text-xs">Uploaded Receipts</span>
        </div>
        <div className="mt-5 lg:mt-0 block md:flex md:space-x-2">
          <TextboxSearch placeholder="Search..." onSearch={handleSearch} />
          <TableControls
            onFilter={() => setShowFilter(true)}
            settings={settings}
          />
        </div>
      </div>
      <div className="mt-1 float-right">
        <div className="flex gap-2">
          {options.year !== "" && (
            <div className="py-1 px-2 flex items-center rounded bg-gray-100 text-gray-500 text-xs">
              {options.year}
              <IoClose
                className="ml-2 cursor-pointer hover:text-red-500"
                onClick={() => handleRemoveFilter(1)}
              />
            </div>
          )}
          {options.quarter !== "" && (
            <div className="py-1 px-2 flex items-center rounded bg-gray-100 text-gray-500 text-xs">
              {renderQuarter(options.quarter)}
              <IoClose
                className="ml-2 cursor-pointer hover:text-red-500"
                onClick={() => handleRemoveFilter(2)}
              />
            </div>
          )}
          {options.is_verified !== "" && (
            <div className="py-1 px-2 flex items-center rounded bg-gray-100 text-gray-500 text-xs">
              {options.is_verified ? "Verified" : "Unverified"}
              <IoClose
                className="ml-2 cursor-pointer hover:text-red-500"
                onClick={() => handleRemoveFilter(3)}
              />
            </div>
          )}
        </div>
      </div>
      <Modal
        title="Filter"
        isOpen={showFilter}
        onClose={() => setShowFilter(false)}
        borderTop
      >
        <ReceiptFilter options={options} onFilter={handleFilter} />
      </Modal>
    </>
  );
};

export default ReceiptHeader;
